import React from 'react';

import {
	FileImageOutlined,
	FileOutlined,
	FileFilled,
	VideoCameraOutlined,
	EyeInvisibleFilled,
} from '@ant-design/icons';

import ProgressiveImage from 'components/ProgressiveImage';
import { getSourcesForVideo, getSourcesForPdf } from '../ProgressiveImage/imageHelpers';
import './MediaItemPreview.scss';

const MediaItemPreview = props => {
	const { handlePickItem, mediaItem } = props;

	const type = mediaItem.mime_type.split('/')[0];
	const secondaryType = type && mediaItem.mime_type.split('/')[1];

	const iconType =
		type === 'image' ? (
			<FileImageOutlined />
		) : type === 'video' ? (
			<VideoCameraOutlined />
		) : (
			<FileOutlined />
		);

	const sources =
		type === 'video'
			? getSourcesForVideo(mediaItem.src)
			: type === 'application'
			? getSourcesForPdf(mediaItem.src)
			: {};

	const allowThumb = type !== 'application' || secondaryType === 'pdf';
	const thumb = sources && sources.thumbnail && allowThumb && (
		<img src={sources.thumbnail} alt={mediaItem.name} />
	);

	return (
		<div
			className={'media-item-thumbnail-container'}
			onClick={handlePickItem ? handlePickItem(mediaItem) : null}
			style={{ cursor: handlePickItem ? 'pointer' : null }}
		>
			<div className="media-item-preview">
				{thumb ? (
					thumb
				) : type === 'image' ? (
					<ProgressiveImage type={mediaItem.mime_type} src={mediaItem.src} alt={mediaItem.name} />
				) : type === 'video' ? (
					<video controls={true} src={mediaItem.src} />
				) : type === 'audio' ? (
					<audio controls={true} src={mediaItem.src} title="mediaItem" />
				) : secondaryType === 'pdf' || secondaryType === 'html' ? (
					<iframe src={mediaItem.src} title="mediaItem" frameBorder="0" scrolling="no" />
				) : (
					<FileFilled style={{ fontSize: '32px', color: 'white' }} />
				)}
			</div>

			<div className="media-item-link">
				<div>{iconType}</div>
				<div className="media-item-name">{mediaItem.name}</div>
				<div className="media-hidden-icon">{mediaItem.hidden ? <EyeInvisibleFilled /> : null}</div>
			</div>
		</div>
	);
};

export default MediaItemPreview;
